module.exports = __webpack_public_path__ + "img/Logo_Strongbow.81d948f7.png";